import { PayloadAction, createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import { fetchFromOldApi } from '~/services/Http';

import { ApplicationConfig } from './types';

export type StoreState = {
  applicationConfig: ApplicationConfig;
  isLoading: boolean;
  failedToLoad: boolean;
  hasData: boolean;
};

const initialState: StoreState = {
  applicationConfig: {} as ApplicationConfig,
  isLoading: false,
  failedToLoad: false,
  hasData: false,
};

export enum ApplicationConfigActionKeyPrefixes {
  FETCH_APPLICATION_CONFIG = 'application/FETCH_APPLICATION_CONFIG',
}

export type ApplicationConfigPayload = {
  applicationConfig: ApplicationConfig;
};

export const getApplicationConfig = (): Promise<ApplicationConfig> =>
  fetchFromOldApi('/json/company/name').then((r) => r.json());

export const fetchApplicationConfig =
  createAsyncThunk<ApplicationConfigPayload>(
    ApplicationConfigActionKeyPrefixes.FETCH_APPLICATION_CONFIG,
    async (): Promise<ApplicationConfigPayload> => {
      return {
        applicationConfig: await getApplicationConfig(),
      };
    },
  );

export const applicationConfigSlice = createSlice({
  name: '~/data/applicationConfig',
  initialState,
  reducers: {},
  extraReducers: {
    [fetchApplicationConfig.fulfilled.type]: (
      state: StoreState,
      action: PayloadAction<ApplicationConfigPayload>,
    ) => {
      state.failedToLoad = false;
      state.isLoading = false;
      state.hasData = true;
      state.applicationConfig = action.payload.applicationConfig;
    },
    [fetchApplicationConfig.pending.type]: (state: StoreState) => {
      state.isLoading = true;
    },
    [fetchApplicationConfig.rejected.type]: (state: StoreState) => {
      state.isLoading = false;
      state.failedToLoad = true;
    },
  },
});

export const applicationConfigReducer = applicationConfigSlice.reducer;
